module.exports = __webpack_public_path__ + "static/viral-shah-400w-103018-1f16fb7cf82fe8daea34e28b6b7a44a2.jpg";